
import { affliateDetails } from "./index";

export const getRefferalDetails = async (userId, token) => {
  try {
    const response = await affliateDetails.get(
      `subscription/referral-transactions/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
